export enum PaymentMethods {
  PetcoPOS = 1,
  Credit = 2,
  Cash = 3,
  SplitPayment = 4,
  Check = 5,
  CareCredit = 6,
  Insurance = 7,
  PCCSmAnimalIncident = 8,
}
